<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordovio/svgVio39bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Lee con atención este texto.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 95px;">
      <p>Tacha las palabras que esten repetidas.</p>
    </span>

    <p class="textBase appearAnimationB" id="crossingText" style="z-index: 6" ref="crossingText">
		"LOS GRILLOS SE REPRODUCEN POR MEDIO DE HUEVOS. EN OTOÑO, CUANDO EMPIEZA EL FRÍO, LOS GRILLOS CAVAN PEQUEÑAS CUEVAS EN LA TIERRA. LUEGO LOS GRILLOS SE METEN EN LAS CUEVAS Y LOS GRILLOS PASAN TODO EL INVIERNO EN LAS CUEVAS."
	</p>

	<span class="normalTheme pageInstruction" style="left: 55px; top: 480px;">
      <p>Entre todos escriban el texto en el pizarrón, dictándole al maestro.</p>
    </span>

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 65px;
    top: 114px;
}
#crossingText
{
position: absolute;
width: 859px;
height: 510px;
left: 78px;
top: 185px;

font-size: 33px;
line-height: 45px;
text-transform: uppercase;

color: #2BB673;
cursor: default;
}
</style>
<script>
	export default {
		methods:{
		dbId(name, option){
			return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
		},
		async loadOption(name, option) {
			var id = this.dbId(name, option);

			var value = await this.$db.options.get({
			id: id,
			}).catch(function(error){
			console.log("error getting option" + error);
			});
			if (value === undefined) return;
			console.log(value);

			if (value.option){
				this.crossWord(option);
			}

			console.log("option loaded: " + id + ", " + value.option);
		},
		saveOption(name, option) {
			var id = this.dbId(name, option);

			var word = document.getElementById(option);
			var c = " highlight"

			var value = word.className.includes(c);

			this.$db.options.put({
				id: id,
				option: value
			}).catch(function(error){
				console.log("error saving option" + error);
			});

			console.log("option saved: " + id + ", " + value);
		},
		setupCrossText(t){
				var words = t.innerHTML.split( " " );
				this.$refs["crossingText"].innerHTML="";
				for (var i = 0; i < words.length; i++) {
				this.$refs["crossingText"].innerHTML += '<span class="crossable" id="crt' + i + '">' + words[i] + "</span>" + " ";
				console.log(words[i]);
				}
				document.querySelectorAll('.crossable').forEach(item => {
					item.addEventListener('click', () => {
					this.crossWord(item.id);
					this.saveOption('crossingText', item.id);
					})
				})
			},
		crossWord(id){
				var word = document.getElementById(id);
				var c = " highlight"
				if (word.className.includes(c)) {
					word.className = word.className.replace(c, "")
				}
				else
				{
					word.className += c;
				}
			}
		},
		mounted(){
			this.setupCrossText(this.$refs["crossingText"]);
			document.querySelectorAll('.crossable').forEach(item => {
				this.loadOption('crossingText', item.id);
			})
		}
	}
</script>